import React from 'react';
import { Route, Redirect } from 'react-router-dom';
//import Loader from 'react-loader-spinner';
import { Role } from '../utils/AccountsAPI';
import { LoadingIndicator } from '../App';

// const Loading = () => {
//   return (
//     <div
//       style={{
//         width: '100%',
//         height: '100%',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//       }}
//     >
//       <div
//         style={{
//           margin: 'auto',
//           display: 'inline-block',
//           top: '45%',
//           position: 'relative',
//         }}
//       >
//         <Loader type='Bars' color='#1976D2' height={50} width={100} />
//       </div>
//     </div>
//   );
// };

export default function ProtectedRoute({
  component: C,
  mobileComponent: M,
  mobileSize = 600,
  props: cProps,
  isAuthenticated: auth,
  roles: cRole = [],
  ...rest
}:
  | {
      component: any;
      mobileComponent?: any;
      mobileSize?: number;
      props?: any;
      isAuthenticated?: boolean;
      roles: string[];
      rest: any;
    }
  | any) {
  return (
    <Route
      {...rest}
      render={(props) =>
        auth === true ? ( //if authenticated
          cProps.employeeInfo != null ? (
            cProps.employeeInfo.id ? ( //if employeeInfo exists
              Authorized(cProps.employeeInfo.roles, cRole) ? ( //if authorized
                M && mobileSize && window.innerWidth < mobileSize ? (
                  <M {...props} {...cProps} {...rest} />
                ) : (
                  <C {...props} {...cProps} {...rest} />
                )
              ) : (
                <Redirect to='/Unauthorized' />
              )
            ) : (
              <LoadingIndicator /> //Loading()
            )
          ) : (
            <LoadingIndicator /> //Loading()
          )
        ) : (
          <Redirect to={{ pathname: '/Login', state: { from: props.location } }} />
        )
      }
    />
  );
}

function Authorized(empRoles: Role[], pageRoles: string[]) {
  var authorized = false;

  if (pageRoles?.length === 0) {
    return true;
  }

  empRoles.forEach((empRole) => {
    authorized = authorized || pageRoles?.indexOf(empRole.name) > -1;
  });

  return authorized;
}
